import React from "react";
import "../css/VariantHeader.css";
import DOMPurify from "dompurify";

const isLikelyHtml = (str) => /<\/?[a-z][\s\S]*>/i.test(str);


const VariantHeader = ({ variantDetails }) => {
  const { name, tripName, variantPhotoLink, description, variantPhotoSource } = variantDetails;

   const renderDescription = (value) => {
    if (!value) return null;
    if (typeof value === "string" && isLikelyHtml(value)) {
      const safe = DOMPurify.sanitize(value, {
        USE_PROFILES: { html: true },
        ADD_ATTR: ["class", "target", "rel"], 
      });
      return (
        <div
          className="variant-description"
          dangerouslySetInnerHTML={{ __html: safe }}
        />
      );
    }

    return <p className="variant-description">{value}</p>;
  };

  return (
    <div className="variant-header">
      <div className="variant-photo-container">
        {variantPhotoLink ? (
          <img src={variantPhotoLink} alt={name} className="variant-photo" />
        ) : (
          <div className="variant-photo-placeholder">Brak zdjęcia</div>
        )}
        <div className="variant-titles-overlay">
          <h1 className="trip-title">{tripName}</h1>
          <h2 className="variant-subtitle">{name}</h2>
        </div>
      </div>
      {variantPhotoSource && (
        <p className="variant-photo-source">Źródło zdjęcia: {variantPhotoSource}</p>
      )}
       {renderDescription(description)}
    </div>
  );
};

export default VariantHeader;
